import styles from "./ConsumablesFormStepSection.module.scss";

type ConsumablesFormStepSectionProps = {
  title: React.ReactNode;
  children: React.ReactNode;
} & Omit<React.FieldsetHTMLAttributes<HTMLElement>, "title">;

export const ConsumablesFormStepSection = ({ title, children, ...restProps }: ConsumablesFormStepSectionProps) => (
  <fieldset data-testid="form-step-section" className={styles.wrapper} {...restProps}>
    <legend className={styles.title}>{title}</legend>
    <div className={styles.contentWrapper}>{children}</div>
  </fieldset>
);
